import {ChronoUnit} from "@js-joda/core";

export const TIME_UNITS = [
    {
        value: ChronoUnit.SECONDS,
        label: "Seconds",
    },
    {
        value: ChronoUnit.MINUTES,
        label: "Minutes",
    },
    {
        value: ChronoUnit.HOURS,
        label: "Hours",
    },
    {
        value: ChronoUnit.DAYS,
        label: "Days",
    },
    {
        value: ChronoUnit.WEEKS,
        label: "Weeks",
    },
    {
        value: ChronoUnit.MONTHS,
        label: "Months",
    },
    {
        value: ChronoUnit.YEARS,
        label: "Years",
    },
];
